import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { 
  FileCheck, 
  Zap, 
  TrendingUp, 
  PiggyBank, 
  Lightbulb, 
  Settings, 
  Sun, 
  Battery, 
  BarChart3 
} from 'lucide-react';

const iconMap = {
  FileCheck,
  Zap,
  TrendingUp,
  PiggyBank,
  Lightbulb,
  Settings,
  Sun,
  Battery,
  BarChart3
};

export const Services = ({ services }) => {
  return (
    <section id="services" className="relative py-32 bg-slate-50 overflow-hidden">
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20 relative">
          {/* Wind turbine background behind headline */}
          <div className="absolute inset-0 -top-16 -bottom-8 opacity-50 rounded-3xl overflow-hidden">
            <div 
              className="absolute inset-0 bg-cover bg-center bg-no-repeat"
              style={{
                backgroundImage: `url('https://customer-assets.emergentagent.com/job_clean-energy/artifacts/pzt1eidb_photo-1562519990-50eb51e282b2.avif')`
              }}
            ></div>
          </div>
          
          <div className="relative z-10">
            <h2 className="text-4xl md:text-5xl font-light text-slate-900 mb-6 tracking-tight">
              Our Services
            </h2>
            <p className="text-xl text-slate-600 font-light max-w-2xl mx-auto">
              Integrated solutions for commercial renewable energy projects.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id} 
                className="group border-0 shadow-sm hover:shadow-lg transition-all duration-300 bg-white"
              >
                <CardHeader className="pb-4">
                  <div className="relative w-16 h-16 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    {/* Gradient background circle */}
                    <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-green-500 to-blue-500 opacity-10 group-hover:opacity-20 transition-opacity duration-300"></div>
                    {/* Inner glow effect */}
                    <div className="absolute inset-2 rounded-xl bg-gradient-to-br from-green-400/20 to-blue-400/20 blur-sm"></div>
                    {/* Icon */}
                    <IconComponent className="relative h-8 w-8 text-green-600 group-hover:text-green-700 transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-lg font-medium text-slate-900 mb-3 group-hover:text-green-600 transition-colors duration-300">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                  <p className="text-slate-600 font-light leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};